import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useApp } from '../contexts/AppContext';
import AuthPageLayout from '../components/ui/AuthPageLayout';

const CheckYourEmail: React.FC = () => {
  const navigate = useNavigate();
  const { state } = useApp();

  const handleSignOut = () => {
    localStorage.removeItem('authToken');
    navigate('/signin');
  };

  return (
    <AuthPageLayout
      title="Check Your Email"
      description="We've sent you a confirmation link"
    >
      <div className="space-y-6">
        <div className="bg-indigo-50 dark:bg-indigo-900/20 border border-indigo-200 dark:border-indigo-800 rounded-lg p-6">
          <div className="flex items-start">
            <div className="flex-shrink-0">
              <svg
                className="h-6 w-6 text-indigo-600 dark:text-indigo-400"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                />
              </svg>
            </div>
            <div className="ml-3 flex-1">
              <h3 className="text-sm font-medium text-indigo-800 dark:text-indigo-300">
                Email Confirmation Required
              </h3>
              <div className="mt-2 text-sm text-indigo-700 dark:text-indigo-400">
                <p>
                  We've sent a confirmation email to{' '}
                  <span className="font-semibold">{state.user?.email}</span>.
                  Please click the link in the email to verify your account and
                  get started.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="space-y-4">
          <div className="text-sm text-gray-600 dark:text-gray-400">
            <p className="mb-3">Didn't receive the email?</p>
            <ul className="list-disc list-inside space-y-1 ml-2">
              <li>Check your spam or junk folder</li>
              <li>Make sure {state.user?.email} is correct</li>
              <li>Wait a few minutes and check again</li>
            </ul>
          </div>

          <div className="text-center pt-4">
            <button
              type="button"
              onClick={handleSignOut}
              className="text-sm text-indigo-600 dark:text-indigo-400 hover:text-indigo-500 dark:hover:text-indigo-300"
            >
              Sign out
            </button>
          </div>
        </div>
      </div>
    </AuthPageLayout>
  );
};

export default CheckYourEmail;
